import { render, staticRenderFns } from "./LoadingRecipientsPage.vue?vue&type=template&id=9454c9e8&"
import script from "./LoadingRecipientsPage.vue?vue&type=script&lang=ts&"
export * from "./LoadingRecipientsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports